import config from '../../config';
import { getAuthHeaders, handleResponse } from './common';

const noteTemplatesApi = {
  listTemplates: async ({ scope, specificScope, includeArchived = false, sortBy, sortDir } = {}) => {
    const params = new URLSearchParams();
    if (scope != null) params.append('scope', scope);
    if (specificScope != null) params.append('specificScope', specificScope);
    if (includeArchived) params.append('includeArchived', 'true');
    if (sortBy) params.append('sortBy', sortBy);
    if (sortDir) params.append('sortDir', sortDir);
    const qs = params.toString();
    const url = `${config.api.url}/templates${qs ? `?${qs}` : ''}`;
    const res = await fetch(url, { headers: getAuthHeaders() });
    return handleResponse(res);
  },

  getTemplate: async (id) => {
    const res = await fetch(
      `${config.api.url}/templates/${id}`,
      { headers: getAuthHeaders() }
    );
    return handleResponse(res);
  },

  createTemplate: async (payload) => {
    const res = await fetch(
      `${config.api.url}/templates`,
      {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
      }
    );
    return handleResponse(res);
  },

  updateTemplate: async (id, payload) => {
    const res = await fetch(
      `${config.api.url}/templates/${id}`,
      {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
      }
    );
    return handleResponse(res);
  },

  archiveTemplate: async (id) => {
    const res = await fetch(
      `${config.api.url}/templates/${id}/archive`,
      {
        method: 'POST',
        headers: getAuthHeaders(),
      }
    );
    return handleResponse(res);
  },

  restoreTemplate: async (id) => {
    const res = await fetch(
      `${config.api.url}/templates/${id}/restore`,
      {
        method: 'POST',
        headers: getAuthHeaders(),
      }
    );
    return handleResponse(res);
  },

  listVersions: async (id) => {
    const res = await fetch(
      `${config.api.url}/templates/${id}/versions`,
      { headers: getAuthHeaders() }
    );
    return handleResponse(res);
  },

  promoteVersion: async (id, versionId) => {
    const res = await fetch(
      `${config.api.url}/templates/${id}/versions/${versionId}/promote`,
      {
        method: 'POST',
        headers: getAuthHeaders(),
      }
    );
    return handleResponse(res);
  },

  copyTemplate: async (id, payload) => {
    const res = await fetch(
      `${config.api.url}/templates/${id}/copy`,
      {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
      }
    );
    return handleResponse(res);
  },
};

export default noteTemplatesApi;
